import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import LinkUI from '@material-ui/core/Link';
import me from './Maurice.jpg';
import cvFile from "./CV.pdf"; // adjust path as needed






const useStyles = makeStyles({
  root: {
    marginTop: 30,
    width: '100%',
    padding: '3%',
    margin: 'auto',
    fontSize: '16',
    minWidth: 600,
  },
  p: {
    color: '#333333',
    paddingTop: 0,
    marginTop: 12,
    fontSize: 16
  },
  h4: {
    paddingLeft: 0,
    textAlign: 'left',
    color: '#009688',
    //color: '#6a737b',
    marginTop: 0,
    marginBottom: 20,
    marginLeft: 0
  }

});



function Contact() {

  const classes = useStyles();



  return (
    <div >


      <Grid container spacing={2} style={{
        paddingTop: 0, paddingLeft: '3%', marginTop: 70, backgroundColor: '#E6EBE9',
        padding: '5%', marginBottom: -20
      }}>

        <Grid item justify="left" xs={12} sm={6} style={{ minWidth: 200, borderLeft: '0.03em solid grey', paddingTop: 0, paddingLeft: '3%', marginTop: 0 }} >
          <Typography variant="h4" className={classes.h4}>
            Contact
          </Typography>

          <Typography variant="body2" className={classes.p} style={{ paddingTop: 24 }} >
Sapienza Università di Roma <br/>
Dipartimento di Matematica<br/>
Piazzale Aldo Moro n. 5,<br/> 00185 Roma<br/> Italy<br/>
          <br/>
            E-mail: maurice.duits@uniroma1.it<br />
           <br />
          <br />
            Below is a short CV, a more detailed CV can be found{" "}
      <a href={cvFile} download="CV.pdf" target="_blank" rel="noopener noreferrer">
        here
      </a>
    
    
          </Typography>


        </Grid>
        <Grid item xs={12} sm={6} style={{ justifyContent: 'center', alignItems: 'center', minWidth: 200 }}>
          <Typography variant="h4" style={classes.h1} >   .</Typography>
          <img src={me} style={{ flex: 1, align: 'right', height: 290 }} ></img>

        </Grid>
      </Grid>
      <Grid container justify="left" spacing={2} style={{
        paddingTop: 0, paddingLeft: '3%', marginTop: 0, paddingBottom: 0, backgroundColor: '#E6EBE9',
        padding: '5%'
      }}>


        <Grid item xs={3} sm={3} style={{ minWidth: 200, borderLeft: '0.03em solid grey', paddingTop: 0, paddingLeft: '3%', marginTop: 0, }} >
          <Typography variant="h4" className={classes.h4} >
            Short CV
          </Typography>
          <Typography className={classes.p}>

          </Typography>


          <Typography variant="h6" style={{ color: '#009688', fontStyle: 'italic' }}>
            Positions
          </Typography>
          <Typography className={classes.p}>

              2026-current <br /> Professor Ordinario, Sapienza University Rome<br /><br />
            2025-2026 <br /> Chaire d'Excellence, Sorbonne University, LSMP<br /><br />
            2021-current <br /> Full Professor (on leave)<br />KTH<br /><br />
            2015-2021 <br /> Associate Professor<br />KTH<br /><br />
            2014  <br />Associate Professor<br /> Stockholm University<br /><br />
            2011-2013  <br /> Postdoctoral Researcher <br />KTH<br /><br />
            2008-2011 <br /> Taussky-Todd Instructor<br /> Caltech<br /><br />
            2004-2008 <br /> PhD student<br />  KULeuven<br />  <br />
          </Typography>
        </Grid>

        <Grid item xs={3} sm={3} style={{ minWidth: 200, margin: 0, paddingLeft: '3%', paddingTop: 0 }} >
          <Typography variant="h4" style={{ color: '#E6EBE9' }}> .  </Typography>
          <Typography className={classes.p}>

          </Typography>



          <Typography variant="h6" style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}>
            Degrees
          </Typography>
          <Typography className={classes.p}>


            2013 <br /> Docent in Mathematics<br /> KTH<br /><br />

            2008 <br /> Ph.D. in Mathematics <br /> KULeuven<br />
            <br />
            2004 <br /> M.Sc. Applied Mathematics<br /> TU Eindhoven<br /> <br />
          </Typography>

          <Typography variant="h6" style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}>
            Awards
          </Typography>
          <Typography className={classes.p}>
            2026 <br />  Strömer-Ferrnerska Award<br/> <br/>

            2025 <br /> Chaire d'Excellence FSMP<br /> <br />


            2017 <br /> Wallenbergprize of the Swedish Mathematical Society <br /><br />

            2016 <br /> Stora Pris GG stiftelse (UU/KTH)
          </Typography>

        </Grid>

        <Grid item xs={3} sm={3} style={{ minWidth: 200, margin: 0, paddingLeft: '3%', paddingTop: 0 }} >
          <Typography variant="h4" style={{ color: '#E6EBE9' }}> .  </Typography>
          <Typography className={classes.p}>

          </Typography>




          <Typography variant="h6" style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}>
            Grants
          </Typography>
          <Typography className={classes.p}>
            2021 <br /> ERC consolidator grant, project: Patterns in Random Tilings (PiRaT)  (2mEUR)<br /><br />
            2016 <br /> Project Grant 2016-05450 from the Swedish Research Council (VR), (2.8mSEK)<br /><br />
            2016 <br /> KAW grant for recruitment of  researchers from outside Sweden (1.5mSEK) <br /><br />
            2016 <br />  GG stora pris (2.5mSEK)<br /><br />
            2012 <br /> Young Researcher Grant 2012-3128 from the Swedish Research Council, (3.2 mSEK)<br /><br />

          </Typography>
        </Grid>


        <Grid item xs={3} sm={3} style={{ minWidth: 200, margin: 0, paddingLeft: '3%', paddingTop: 0 }} >
          <Typography variant="h4" style={{ color: '#E6EBE9' }}> .  </Typography>
          <Typography className={classes.p}>

          </Typography>



          <Typography variant="h6" style={{ marginTop: 15, color: '#009688', fontStyle: 'italic' }}>
            Organized events
          </Typography>
          <Typography className={classes.p}>
            Fall 2024 <br /> Semester long program on: <br /> Random Matrices and Scaling Limits <br />
            Institut Mittag-Leffler, Stockholm <br /> <br />
            May 2024 <br />  Asymptotics, Randomness, Nonlinearity, Orthogonality (ARNO), KULeuven <br />
            <br /> <br />
            May 2023 <br /> Random Schrödinger Operators and Random
            Matrices, Midrasha Mathematicae<br /><br />
            June 2022  <br /> Random matrices and beyond, Stockholm <br /><br />

            June 2018 <br />  Workshop "Gaussian fields in Random Matrix Theory", Mittag-Leffler, June 2018 <br /> <br />
            January 2015 <br /> Stockholm Uppsala Analysis Probability Day II,  Uppsala University <br /> <br />
            May 2014 <br /> Workshop ”Random matrices and Jacobi operators”, Mittag-Leffler Institute  <br /> <br />
            January 2014 <br /> Stockholm Uppsala Analysis Probability Day I, Stockholm University <br /> <br />
          </Typography>
        </Grid>
      </Grid>
    </div>
  );
}


export default Contact